const RESIDENTIAL_SCOPE_ZONE_CODES = new Set([
    'R1',
    'R2',
    'R3',
    'R4',
    'R5',
    'MU1',
    'SP5',
    'RU1',
    'RU2',
    'RU4',
    'RU5',
    'RU6',
    'C3',
    'C4'
]);

function normalizeZoneCode(zone) {
    const normalized = zone
        .trim()
        .toUpperCase()
        .replace(/^ZONE\s+/, '');
    return normalized.match(/^[A-Z][A-Z0-9]*(?=$|[\s:])/)?.[0] || '';
}

/**
 * INVARIANT: Any in-scope comma/semicolon component permits assistance only,
 * not development across the parcel. The original zone string is not rewritten.
 * Empty/unparseable input does not establish an out-of-scope zone.
 * @param {unknown} zone
 * @returns {boolean}
 */
export function isOutsideResidentialScope(zone) {
    if (typeof zone !== 'string') return false;
    const codes = zone.split(/[,;]/).map(normalizeZoneCode).filter(Boolean);
    return codes.length > 0 && !codes.some((code) => RESIDENTIAL_SCOPE_ZONE_CODES.has(code));
}
